const getStaticPageLdJson = (router, pageProps, seoConfig) => {
  if (!pageProps) return {}
  const { navigationalParents = [], title } = pageProps
  const rootLevelPageName = navigationalParents[0]?.title

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@id': `${ensureSingleTrailingSlash(`${seoConfig?.hostUrl}/${router?.query?.locale}`)}shop/`,
          name: `${rootLevelPageName}`,
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@id': `${ensureSingleTrailingSlash(`${seoConfig?.hostUrl}${router?.query?.urlKey}`)}`,
          name: `${title}`,
        },
      },
    ],
  }
}

const ensureSingleTrailingSlash = (url) => {
  if (!url) return ''
  return url.endsWith('/') ? url : `${url}/`
}

export { getStaticPageLdJson }
